import React from "react";
import { cn } from "../../lib/utils";

const StepProgress = ({ steps, currentStep, className }) => (
  <div className={cn("w-full", className)} role="progressbar" aria-valuenow={currentStep + 1} aria-valuemin={1} aria-valuemax={steps.length}>
    <div className="flex gap-1 mb-2">
      {steps.map((_, idx) => (
        <div
          key={idx}
          className={cn("h-1 flex-1 rounded-full transition-colors", idx <= currentStep ? "bg-red-700" : "bg-slate-200")}
        />
      ))}
    </div>
    <p className="text-sm text-slate-600">
      Step {currentStep + 1} of {steps.length}
    </p>
  </div>
);

export default StepProgress;
